import { p as prisma } from "../../../../chunks/prisma.js";
const GET = async ({ locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  const cats = await prisma.category.findMany({ orderBy: { name: "asc" } });
  return new Response(JSON.stringify(cats));
};
const POST = async ({ request, locals }) => {
  if (!locals.user) return new Response("Unauthorized", { status: 401 });
  const body = await request.json();
  const isHex = typeof body.colorHex === "string" && /^#([0-9A-Fa-f]{6})$/.test(body.colorHex);
  if (!body.name || !isHex) return new Response("Bad Request", { status: 400 });
  const cat = await prisma.category.create({ data: { name: body.name, colorHex: body.colorHex } });
  return new Response(JSON.stringify(cat), { status: 201 });
};
export {
  GET,
  POST
};
